<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close(result)">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">


            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نوع تراکنش : </span>
                    <span *ngIf="lang == 2"> Document type : </span>
                    <span (click)="reset_input(177)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="payment_type_title" (click)="load_services(177) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="payment_type" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="type_task != 3">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نام طرف حساب : </span>
                    <span *ngIf="lang == 2"> User : </span>
                    <span (click)="reset_input(161)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="user_title" (click)="load_services(161) " readonly>
                    <input class="wh-input" formControlName="user" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="cheque == false">
                <label for="user" class='wh-label'>
                    <span *ngIf="lang == 1"> چک: </span>
                    <span *ngIf="lang == 2"> Select Cheque : </span>
                    <span (click)="select_introducing_cheque()" *ngIf="document_type == 1">
                        <i class="fas fa-bookmark cursor"
                            style="float: left; font-size: 1rem; padding-bottom: 2px;"></i>
                    </span>
                    <span (click)="reset_input(181)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="cheque_title" (click)="select_cheque()"
                        [required]="cheque == true && type_task != 3" readonly>
                    <input class="wh-input" formControlName="cheque" [hidden]="true"
                        [required]="cheque == true && type_task != 3" readonly>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="cheque == true || type_task == 3">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> مبلغ : </span>
                    <span *ngIf="lang == 2"> Amount : </span>
                    <input class='wh-input' formControlName="amount" autocomplete="off" currencyMask
                        [required]="cheque == false && type_task != 3">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>


        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button [disabled]="!form1_group.valid || loading" class="btn_pe" (click)="save(type_task,1,'close')"
            [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 1">ذخیره و بستن</span>
        </button>
        <button [disabled]="!form1_group.valid || loading" class="btn_pe" (click)="save(type_task,1,'no_close')"
            [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 1">
            <span *ngIf="lang == 1"> ذخیره </span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>